import { render, staticRenderFns } from "./menuButton.vue?vue&type=template&id=b0f92c84&"
import script from "./menuButton.vue?vue&type=script&lang=js&"
export * from "./menuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports